/*
https://closure-compiler.appspot.com/home
https://obfuscator.io/

・命名ルール：
　アプリ共通：c(common), アプリ個別・モジュール共通：i(individual), アプリ個別・モジュール個別：p(paticular) or _(underscore)

・map のメリットは、処理結果を即配列に代入できること、記述が簡素化されること

・map はスキップされるため await を必要に応じて使用する

・map の引数関数を async する場合は、await Promise.all で map を括る必要がある
  await Promise.all(_ld_iss.map(async _d_is => {
    return await _o_fnc();
  }));

・promise の結果は、スコープの広い変数を用いて共有する

・pck の初期化 は -1 で行う

・this.$osr は処理が循環しないよう、データの流れに注意する（幹から枝へ処理する）、原則として fld の更新のみに使用し、load の代替としては使用しない

・sgc_pageKey は iv.load において設定しない（iv.load は 複数モジュールで使用されるため）

・setState を同時並行で実施した場合、処理が適切に行われない場合がある

・アップグレード時の対応事項


・コンポーネントの作り方
　・state で 仮のデータを作る
　・コンポーネントの表示機能を作成し仮のデータを表示する（select）
　・仮のデータを変更可能とする（update）
　・仮のデータを追加登録可能とする（insert）
　・仮のデータを削除可能とする（delete）

・immer は本体の差し替えには対応していないもよう
・immer による代入と、通常の代入は混在できないもよう
・配列コンポーネントにおいて、変更前後で key が異なる場合、コンポーネントが正しく入れ替わらない事になる

・iphone では margin / padding を top/bottom/left/right の別に指定する必要がある
・要素には、必ず、階層ごとにユニークな key を設定すること

・function や state を介したコンポーネントは、state の変更や共有が正しく行われないことがある ＞ RN の伝搬ルールを理解する必要がある

・stl は別に分ける必要がありそう

・シンプルなプログラム構造とする
・複数関数をまたいだ listener は実行されない模様、component から直接関数を呼び出す必要がある
・値は、this.state.am1a1020 で参照、引数は構造体となっており直接値を参照できない
・複数のモーダルを切り替えて画面遷移させることはできない模様、その場合、コンポーネントを分けるか、overlay か、ほかのダイアログの使用を検討か？
・起動直後に落ちる場合は、import に正しく名前が設定されているか、import されてない要素が render で使われていないか、無効なコンポートがApp.jsでインポートされていないか、c.jsx に無効な関数が含まれていないか
・alert は 2 以上同時に表示されることはないらしい
・encountered two childre with the same key は、複数のコンポーネントで class 名が重複している場合に発生？
・javascript
  0 == false, 1 == true, _l.update = _l.push, _d.update = _d.assign
・動かない理由は、関数名が誤っている、let/const がついていない
・Value for title can not be cast from double to string
　→ title の "" を '' に変える
・callable function の中で class の this は機能しない
・for 文の後の処理は平行して実行される　→ myCM_for_each2 を使用
・Possible unhandled promise rejection
　→ then の後は同じ型のデータを返す catch を必ずつける
・function 中の this において state は無効、全て _o_this として引用
・this.state において state の付け忘れがないかを確認
×setState は 変数ベースでは機能せず、必ず、{} で変更対象の状態変数を具体的に記載する必要がある模様
・setState を用いた際は、await したいと状態の同期がとれない場合がある
・react native や 関連するモジュールの仕様が変更され、従来の設定では正しく動作しなくなる場合があることに注意
・状態変数がコンポーネントの引数に含まれていない場合、状態変化は伝搬しない模様

// common program として実現したいこと
* 選択されたメニューをハイライト表示する？
* 画面を遷移した際に、pageName と pageKey を push & delete する　－＞ javascript の push / pop を使えばよい
済　* 画面を遷移した際に、状態変数を全てクリアする


expo upgrade

// for common
expo install immer
expo install base-64
expo install lz-string
expo install papaparse
expo install utf8
expo install buffer
expo install encoding-japanese

// for native & web
expo install @react-native-async-storage/async-storage
expo install @react-navigation/native
expo install @react-navigation/stack
expo install expo-document-picker
expo install expo-image-picker
expo install expo-permissions
expo install expo-sharing
expo install react-native-mime-types
expo install react-native-screens
expo install react-native-vector-icons
expo install expo-clipboard
expo install expo-checkbox

// only for web
expo install file-saver
expo install react-dropzone
expo install victory
expo install jspdf
expo install react-rnd
expo install qrcode

// only for native
expo install victory-native
expo install react-native-svg
expo install react-native-unimodules
expo install expo-file-system
expo install expo-media-library
expo install react-native-gesture-handler

//expo install react-datepicker
//expo install expo-constants
//expo install expo-updates
//expo install expo-intent-launcher
//expo install react-native-step-indicator
//expo install react-native-paper
//expo install react-native-calendars
//expo install react-navigation
//expo install react-navigation-stack
//expo install modal-enhanced-react-native-web
//expo install react-native-icon-badge
//expo install react-native-modal
//expo install react-native-picker-select
*/


// for myRN
import { 
  Alert,
  Dimensions,
  Keyboard,
  Linking, 
  Platform, 
  StatusBar,
//    StyleSheet,
} from "react-native"; 

// for myLS
import AsyncStorage from '@react-native-async-storage/async-storage'

// for expo
import * as DocumentPicker from 'expo-document-picker';
import * as FileSystem from 'expo-file-system';
import * as ImagePicker from 'expo-image-picker';
import * as Permissions from 'expo-permissions';
import * as Sharing from 'expo-sharing';
import * as Clipboard from 'expo-clipboard'; // 1.0.2 only 

/*
import {
    Constants,
    //DocumentPicker,
    Permissions,
    ImagePicker,
    Updates,
    FileSystem,
} from 'react-native-unimodules' // for react-native
*/

import * as mime from 'react-native-mime-types'; // for mimeType

import { CommonActions } from '@react-navigation/native';

import ff from './ff';
import bf from './bf';
import ic from './ic';
//import iv from './iv';

import df from './df_20211115';

import myWB from './myWB_20211212';

import iElm from './iElm';

export default class cf { // common function
    
  //////////////////////////////////////////////////////////////////////// 

  static c = (p_elm, p_cnd, pb_fnd=false, pb_ltt=true) => {
    let _cnd = ` COALESCE(t_${p_elm}.${p_elm}cz1i, 10) <> 0`;
    _cnd += (pb_fnd != true) ? ` AND t_${p_elm}.${p_elm}b21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}` : ''; // c40 等 基盤機能への対応
    _cnd += (pb_ltt != false) ? ` AND t_${p_elm}._vsn = t_${p_elm}._ltt` : ''; // c40 等 基盤機能への対応
    if (p_cnd) _cnd += ` AND (${p_cnd})`;
    if (ic.gb_dbg) ff.l('cf 195: {}, {}'.f(pb_fnd, _cnd))
    return _cnd;
  };

  static e = (p_elm, pd_vals=null, pn_vsn=0) => {
    let _elm = p_elm;
    let _d = ff.c(iElm.d_elmDefs[_elm][pn_vsn], pd_vals);
    return _d;
  };

  static f = (p_fld, pd_vals, pn_vsn=0) => {
    let _elm = p_fld.substr(0, 4);
    let _d = {
      [`${_elm}cx1i`]: { // 要修正
        pfx: '表示順',
        type: 'Inp',
      },
      [`${_elm}cy1t`]: { // 要修正
        pfx: '登録日時',
      },
      [`${_elm}cy1f`]: { // 要修正
        pfx: '登録者',
      },
      [`${_elm}cz1i`]: { // 要修正
        pfx: '削除区分',
        type: 'Pck',
        ld_iss: [
          { key: 0, pfx: '削除する' },
          { key: 10, pfx: '削除しない' },
        ],
        n_col: 6,
      },
      ...iElm.d_elmDefs[_elm][pn_vsn].dd_fldDefss[p_fld], 
      ...pd_vals,
    };
    if (bf.f(_d) == false) alert('186: dd_fldDefss does not defined for {}'.f(p_fld))
    _d = {
      fld: p_fld,
      n_col:
        (String(p_fld).substr(7,1) == 'd') ? // 末尾が d の場合
          8
        : 10,
      n_prt:
        (String(p_fld).substr(7,1) == 'd') ? // 末尾が d の場合
          10
        : (_d.n_prt) ? 
          _d.n_prt 
        : (_d.n_col) ? 
          _d.n_col
        : 10,
      o_stlVal:
        (bf.i(String(p_fld).substr(7,1), ['i', 'f', 'm'])) ?
          _d_dats => ((_d_dats.d_flds[p_fld]) ? bf.myCM_cnv('cmm', _d_dats.d_flds[p_fld]) : 0)
        : (String(p_fld).substr(7,1) == 'd') ? // 末尾が d の場合
          _d_dats => ((_d_dats.d_flds[p_fld]) ? String(_d_dats.d_flds[p_fld]).substr(0,10) : '')
        : null,
      aln:
        bf.i(String(p_fld).substr(7,1), ['i', 'f', 'm']) ? 
//          'right'
          null
        : null,
      o_onFldPrs: 
        (global.t?.state.sgc_pnlMode == 'list' && _d.b_key) ?
          _d_dats => {
            cf.s();
            global.t?.setState({
              sgc_pageKey: _d_dats.d_flds._key,
              sgc_pageFst: _d_dats.d_flds._fst,
              sgcn_step: 0,
            }, () => {
              global.t?.op_loadDtlAll()
              .then(() => {
                global.t?.setState({
                  sgc_pnlMode: 'dtl',
                  sgc_pageMode: 'show',
                }, () => { // sgc_pnlMode が変更されているこのタイミングで opb_chk を行う
//                  if (global.t?.$opb_chk) global.t?.$opb_chk(false); // チェック処理
                  cf.h();
                });
              })
            });
          }
        : null,
      o_stlCta: 
        (_d.b_frm == true) ? // フレームを表示する場合
          _d_dats => { // 毎回定義するのが面倒なので初期値化
            let _d = {
              borderColor: (global.t?.state.sgc_pageKey == _d_dats.d_flds._key) ? ic.o_getCcd('d') : ic.g_backCcd,
              borderWidth: ic.gn_bdrWNrm,
              borderRadius: ic.gn_bdrRdsNrm,
            };
            return _d;
          }
        : null,
      ..._d,
    };

    return _d;
  };

  static s = cf.myRN_showLdr;

  static h = cf.myRN_hideLdr;

  static w = (p_tgt, pn_cnt=0) => {
    const _n_bdyW = ic.gn_bdyW;
    if ( p_tgt == 'bdy') {
      return (pn_cnt > 0) ? ((_n_bdyW - ic.s(0.5) * (pn_cnt + 1)) / pn_cnt) : _n_bdyW
    };
    const _n_mdlW = _n_bdyW - ic.s(0.5) * 2;
    if ( p_tgt == 'mdl') {
      return (pn_cnt > 0) ? ((_n_mdlW - ic.s(0.5) * (pn_cnt + 1)) / pn_cnt) : _n_mdlW
    };
  }
  //////////////////////////////////////////////////////////////////////// for callback

//static myCB_call_eml = (p_ars, p_sjt, p_msg) => new Promise( _o_end1 => { // 汎用メール送信
static myCB_call_eml = (pl_tos, p_sjt, p_msg, pl_bccs=null) => new Promise( _o_end1 => { // 汎用メール送信
  ff.myCR_send_json({
    method: 'POST',
    url: ic.g_url1,
    type: 'mail',
    d_vals: {
//      ars: p_ars,
      l_tos: pl_tos,
      sjt: p_sjt,
      msg: p_msg,
      l_bccs: pl_bccs,
    },
  })
  .then( _d_res => {
    _o_end1(_d_res);
  });
});

static myCB_call_code = (p_c00rc11s) => new Promise( _o_end1 => { // 確認コードの確認
  ff.myCR_send_json({
    method: 'POST',
    url: ic.g_url1,
    type: 'code',
    d_vals: {
      c00rc11s: p_c00rc11s,
    },
  })
  .then( _d_res => {
    _o_end1(_d_res);
  });
});

static myCB_call_cnf = (p_c00rc11s, p_c00ri11s) => new Promise( _o_end1 => { // 確認コードの確認
  ff.myCR_send_json({
    method: 'POST',
    url: ic.g_url1,
    type: 'cnf',
    d_vals: {
      c00rc11s: p_c00rc11s,
      c00ri11s: p_c00ri11s,
    },
  })
  .then( _d_res => {
    _o_end1(_d_res);
  });
});

static myCB_call_dmn = (p_dmn) => new Promise( _o_end1 => { // 確認コードの確認
  ff.myCR_send_json({
    method: 'POST',
    url: ic.g_url1,
    type: 'dmn',
    d_vals: {
      name: p_dmn,
    },
  })
  .then( _d_res => {
    _o_end1(_d_res);
  });
});

  static myCB_call_dwl = (pd={
    elm: '', 
    tgt: '',
  }) => new Promise( _o_end1 =>{
    let _ld_valss = [
      {key:'data', vals:{ usr:global.t?.state.sgc_user_key, tkn:global.t?.state.sgc_tkn, mode:'dwl', ctr:'', prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
        tgt:pd.tgt,
      }},
    ];
    cf.myCR_xhr({
      mode: 'POST',
      url: ic.g_url1,
      ld_valss: _ld_valss
    })
    .then((_a_res) => {
      if (bf.f(_a_res)) {
        cf.myRN_open_url('{}/{}'.f(ic.g_url2, _a_res.file))
        .then( () => {
          _o_end1(_a_res);
        });
      }
      else {
        _o_end1(null);
      }
    });
  });

  static myCB_call_iud = (pd={
    ctr: '', 
    elm: '', 
    d_vals: {}, 
    cnd: '', 
    qry: '', 
    l_qrys: []
  }) => new Promise( async _o_end1 => {
    if (pd.ctr == 'qrys') {
      ff.myCR_send_json({
        method: 'POST',
        url: ic.g_url1, 
        type: 'iud',
        d_vals: {
          ctr: 'qrys',
          elm: pd.elm,
          l_qrys: pd.l_qrys,
        }
      })
      .then((_a_res) => {
        _o_end1(_a_res);
      });

    }
    else if (pd.ctr == 'ins'){
      if (pd.cnd) { // 強制 ins
        if ((pd.n_cnt ?? 0) > 10) {
          alert('387: データの反映を確認できませんでした\n {}'.f(pd.elm))
          _o_end1(null);
        }
        else { // !!!!! 旧式の call_slc で上手く動作しない可能性
          cf.myCB_call_slc({ // 事前確認
            ctr: 'nlm', 
            elm: pd.elm, 
            n_dms: 2, 
            cnd: pd.cnd,
          })
          .then( async _d_rs => {
            if (bf.f(_d_rs)) { // ins されてる場合
              _o_end1(_d_rs);
            }
            else { // ins されてない場合
              ff.myCR_send_json({
                method: 'POST',
                url: ic.g_url1, 
                type: 'iud',
                d_vals: {
                  ctr: 'ins',
                  elm: pd.elm,
                  d_vals: pd.d_vals,
                }
              })
              .then(() => {
                cf.myCB_call_iud({
                  ctr: 'ins', 
                  elm: pd.elm, 
                  d_vals: pd.d_vals,
                  cnd: pd.cnd,
                  n_cnt: (pd.n_cnt ?? 0) + 1,
                })
                .then( _d_rs => {
                  _o_end1(_d_rs);
                })
              })
            }
          });
        };
      }
      else { // 通常 ins
        ff.myCR_send_json({
          method: 'POST',
          url: ic.g_url1, 
          type: 'iud',
          d_vals: {
            ctr: 'ins',
            elm: pd.elm,
            d_vals: pd.d_vals,
          }
        })
        .then((_a_res) => {
          _o_end1(_a_res);
        });
      }
    }
    else if (pd.ctr == 'upd'){
      ff.myCR_send_json({
        method: 'POST',
        url: ic.g_url1, 
        type: 'iud',
        d_vals: {
          ctr: 'upd',
          elm: pd.elm,
          d_vals: pd.d_vals,
          cnd: pd.cnd,
        }
      })
      .then((_a_res) => {
        _o_end1(_a_res);
      });
    }
    else if (pd.ctr == 'ups'){
      ff.myCR_send_json({
        method: 'POST',
        url: ic.g_url1, 
        type: 'iud',
        d_vals: {
          ctr: 'ups',
          elm: pd.elm,
          d_vals: pd.d_vals,
          cnd: pd.cnd,
        }
      })
      .then((_a_res) => {
        _o_end1(_a_res);
      });
    };
  });

  static myCB_call_slc = (pd={
    elm: '', 
    n_dms: 3,
    fld: '',
    cnd: '', 
    qry: '', 
    dd_rfrss: null,
    dld_pcksss: null, 
    d_cashs: null,
    ld_sortss: [{fld:'_key', dtn:'asc', mode:'str/nmb'}], // myRN_call_slc の段階では key などがないことに注意
    d_insFlds: null,
  }) => new Promise( _o_end1 => {
//ff.l('495: here')
    if (
      pd.dd_cashss && 
      pd.dd_cashss[pd.elm] && 
      pd.dd_cashss[pd.elm][pd.cnd]
    ) { // キャッシュが指定されており、キャッシュが存在する場合
//ff.l('501: here')
      _o_end1(pd.dd_cashss[pd.elm][pd.cnd])
    }
    else {
//ff.l('504: here')
      ff.myCR_send_json({
        method: 'POST',
        url: ic.g_url1,
        type: 'slc',
        d_vals: {
          elm: pd.elm,
          n_dms: pd.n_dms,
          fld: pd.fld,
          cnd: pd.cnd,
          qry: pd.qry,
        },
      })
      .then( async _a_res => {
        //
//ff.l('517: here')
        if (pd.n_dms == 3) {
          //
          let _l = [];
//ff.l('521: here')

          if (ff.f(_a_res) == false && pd.d_insFlds) _a_res = [{ _key:-1, ...ff.myCM_copy(pd.d_insFlds) }]; // d_insFlds の _key を忘れずに
//ff.l('524: here')

          for await (let [_idx, _d_vals] of bf.e(_a_res)) {
            //
            let _d_vals2 = {};
            //
            if (bf.f(pd.dd_rfrss)){ // rfrs が定義されている場合
              await Promise.all(
                Object.keys(pd.dd_rfrss)
                .map( _als => new Promise( _o_end2 => {
                  let _elm = pd.dd_rfrss[_als].elm ?? _als;
                  let _cnd = pd.dd_rfrss[_als].o_cnd(_d_vals);
                  let _dd_rfrss = pd.dd_rfrss[_als].dd_rfrss;
                  if (_cnd) {
                    cf.myCB_call_slc({
                      elm: _elm, 
                      n_dms: 3, 
                      cnd: _cnd,
                      dd_rfrss: _dd_rfrss, // 再帰構造は上書きされる
                      dd_cashs: pd.dd_cashss,
                    })
                    .then( _ld_vals3 => {
                      if (bf.f(_ld_vals3)) { // データが存在した場合
//ff.l('594: {}'.f(_ld_vals3))
                        let _d_vals3 = _ld_vals3[0];
                        _d_vals2['{}_key'.f(_elm)] = _d_vals3._key; // 再帰構造を考慮し名称を上書きしない(_als)
                        _d_vals2['{}_vsn'.f(_elm)] = _d_vals3._vsn; // 再帰構造を考慮し名称を上書きしない
                        _d_vals2['{}_ltt'.f(_elm)] = _d_vals3._ltt; // 再帰構造を考慮し名称を上書きしない
                        _d_vals2['{}_fst'.f(_elm)] = _d_vals3._fst; // 再帰構造を考慮し名称を上書きしない
                        Object.keys(_d_vals3)
                        .filter( _fld => bf.i(_fld, ['_key', '_vsn', '_ltt', '_fst']) ? false : true )
                        .map( _fld => {
                          _d_vals2[_fld] = _d_vals3[_fld]; // 再帰構造を考慮し名称を上書きしない、'{}{}'.f(_als, _fld.substr(4,4)) は NG
                        });
                        _o_end2();
                      }
                      else {
//ff.l('608: {}'.f(_ld_vals3))
                        _o_end2();
                      };
                    });
                  }
                  else{
                    _o_end2();
                  };
                }))
              );
            };

            _d_vals2 = bf.myCM_upd(_d_vals2, _d_vals);
            //
            if (bf.f(pd.dld_pcksss)){ // pcks が定義されている場合
              for await (let [_fld, _ld_pckss] of bf.e(pd.dld_pcksss)) { // _d_defs.pcks は通常の pcks と同形式であること {key:{key:'', pfx:''}}
                if (_d_vals2[_fld] && bf.myCM_getDny({ld_iss:_ld_pckss, fld:'key', val:_d_vals2[_fld]})) {
                  _d_vals2[_fld] = bf.myCM_getDny({ld_iss:_ld_pckss, fld:'key', val:_d_vals2[_fld]}).pfx;
                }
              };
            };
            //
            _l.push(_d_vals2)
          };
          _a_res = _l;
          let _a_res2 = bf.f(pd.ld_sortss) ? bf.myCM_sort({
            ld_iss: _a_res, 
            ld_sortss: pd.ld_sortss,
          }) : _a_res;
          if (pd.dd_cashss){ // キャッシュが指定されている場合
            if (bf.f(pd.dd_cashss[pd.elm]) == false) pd.dd_cashss[pd.elm] = {};
            pd.dd_cashss[pd.elm][pd.cnd] = _a_res2;
          }
          _o_end1(_a_res2);
        }
        else {
          if (pd.dd_cashss){ // キャッシュが指定されている場合
            if (bf.f(pd.dd_cashss[pd.elm]) == false) pd.dd_cashss[pd.elm] = {};
            pd.dd_cashss[pd.elm][pd.cnd] = _a_res;
          }
          _o_end1(_a_res);
        };
      })
      .catch( _err => {
        bf.l('672: {}'.f(_err));
      });
    }
  });


  static myCB_set_clds = (pd={
  }) => new Promise( _o_end1 => {
    if (pd.b_withCnd == true && bf.f(pd.cnd) == false) { // pd.cnd が空白の場合は clds を取得しない
      let _r = []; // list only
      global.t?.setState({
        [pd.state]: _r,
      }, ()=>{
        _o_end1(_r);
      });
    }
    else {
      cf.myCB_call_slc(pd)
      .then( async _ld_iss => { // list only
        global.t?.setState({
          [pd.state]: _ld_iss,
        }, ()=>{
          _o_end1(_ld_iss);
        });
      });
    };
  });

static myCB_set_items = (pd={
  state: '',
  o_fnc: () => null,
}) => new Promise( _o_end1 => {
  cf.myCB_call_slc(pd)
  .then( async _ld_iss => {
    let _ld_valss = [];
    for await (let [_idx, _d_items] of bf.e(_ld_iss)) {
      let _d_items2 = await pd.o_fnc(_d_items);
      _d_items2.key = _d_items._key;
      _d_items2.val = _d_items;
      _ld_valss.push(_d_items2);
    };
    global.t?.setState({
      [pd.state]: _ld_valss,
    }, ()=>{
      _o_end1(_ld_iss);
    });
  })
});

  static myCB_call_rfr(pd_vals, p_elm, p_cnd='', pdd_cashss=null){ // 複数の elm/cnd に対応可能とする
    return new Promise((resolve) => {
      if (pdd_cashss && pdd_cashss[p_cnd]) { // キャッシュが指定されており、キャッシュが存在する場合
        resolve(bf.myCM_upd(pdd_cashss[p_cnd], pd_vals)) // pd_vals の _KEY を消さないよう上書き
      }
      else {
        let _ld_valss = [
          {key:'data', vals:{ usr:global.t?.state.sgc_user_key, tkn:global.t?.state.sgc_tkn, mode:'slc', ctr:'nlm', prc:'', vwi:'', idc:'{}/'.f(p_elm), fld:'',
            dms:2, // 2 固定
            cnd:p_cnd,
          }},
        ];
        cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        })
        .then((_a_res) => {
          if (pdd_cashss){ // キャッシュが指定されている場合
            //
            pdd_cashss[p_cnd] = _a_res;
            resolve(bf.myCM_upd(pdd_cashss[p_cnd], pd_vals)) // pd_vals の _KEY を消さないよう上書き
          }
          else { // キャッシュが指定されてない場合
            resolve(bf.myCM_upd(_a_res, pd_vals)) // pd_vals の _KEY を消さないよう上書き
          }
        });
      }
    });
  };

static myRN_getFstAls = (pd_is) => { // get first alias
  return (pd_is && Object.keys(pd_is)) ? Object.keys(pd_is)[0] : null;
};

static myRN_getFstElms = (pdld_iss) => { // get first element
  let _als =  cf.myRN_getFstAls(pdld_iss);
  return pdld_iss[_als];
};

static myRN_setDat = (p_state, pd_dats, pod_vals) => new Promise( _o_end1 => {
  global.t?.setState({
    [p_state]: bf.p(global.t?.state[p_state], _next => {
      if (ic.gb_dbg) ff.l('cf 682: {}, {}'.f(pd_dats.ld_arsss, p_state))
      let _d_crrDats = cf.myRN_getDat(_next, pd_dats.ld_arsss);
      let _d_vals = pod_vals(_d_crrDats);
      Object.keys(_d_vals).map( _fld => {
        _d_crrDats.d_flds[_fld] = _d_vals[_fld];
        _d_crrDats.b_upd = true;
        if (!bf.f(_d_crrDats.dd_stgss)) _d_crrDats.dd_stgss = {};
        if (!bf.f(_d_crrDats.dd_stgss[_fld])) _d_crrDats.dd_stgss[_fld] = {};
        _d_crrDats.dd_stgss[_fld].b_chg = true;
      });
    }),
  }, () => {
    _o_end1();
  });
});

static myRN_getDat = (pdld_datsss, pld_adrss={als:'',key:-1}, pb_prt=false) => { // pld_elmTreess において pl_pntIdxs/pn_datIdx で指定された dat を取得する
  let _ld_adrss = pld_adrss;
  if ( pb_prt && bf.f(_ld_adrss) ) _ld_adrss = _ld_adrss.slice(0,-1); // 親要素を取得する場合
  if ( bf.f(_ld_adrss) == false ) {
    return pdld_datsss;
  }
  else {
    if (ic.gb_dbg) ff.l('cf 705: {}, {}'.f(_ld_adrss, pdld_datsss))
    let _d_dats = _ld_adrss.reduce( ( _prev, _d_adrs ) => {
      if ( _prev == null ) {
        return bf.myCM_getDny({
          ld_iss: pdld_datsss[_d_adrs.als], 
          fld: 'key', 
          val:_d_adrs.key
        });
      }
      else {
        return bf.myCM_getDny({
          ld_iss: _prev.dld_cldDatsss[_d_adrs.als], 
          fld: 'key', 
          val:_d_adrs.key
        });
      };
    }, null);
    return _d_dats;
  };
};

static myRN_getDatByAlss = ( pdld_datsss, pl_als) => {
  if (ff.myCM_getLen(pl_als) == 1) { // 子要素が存在しない場合
    let _crrAls = pl_als[0];
    return pdld_datsss[_crrAls];
  }
  if (ff.myCM_getLen(pl_als) > 1) { // 子要素が存在する場合
    let _crrAls = pl_als[0];
    let _l = [];
    pdld_datsss[_crrAls].map( _d_crrDats => {
      let _dld_cldDatsss = _d_crrDats.dld_cldDatsss;
      let _l_cldAls = pl_als.slice(1);
      _l = ff.c(_l, cf.myRN_getDatByAlss(_dld_cldDatsss, _l_cldAls));
    });
    return _l;
  }
  if (ff.myCM_getLen(pl_als) < 1) {
    return null;
  };
  
}; 

static myRN_getMenuDefss = () => {
  if (ff.myCM_getLen(global.t?.state.sgcdd_menuDefss) > 1) {
    return global.t?.state.sgcdd_menuDefss
  }
  else {
    return ic.godd_menuDefss(global.t?.state.sgc_pageRole)
  };
}

static myRN_setStt = (
  pd_nexts,
  po_this=null,
) => new Promise( _o_end1 => {
  let _o_this = po_this ?? global.t;
  if (pd_nexts) {
//    if (_o_this.d_crls?.d_myRNs.b_stt ?? false) { // 重複実行を回避
    if (false) { // 重複実行を回避, 一時的に無効化
      ff.myCM_wait(0.01)
      .then(() => {
        if (ic.gb_dbg) ff.l('815: batting {}'.f(pd_nexts))
        cf.myRN_setStt(pd_nexts, _o_this)
        .then(() => {
          _o_end1();
        });
      });
    }
    else {
      _o_this.d_crls.d_myRNs.b_stt = true;
/*
      Object.keys(pd_nexts)
      .map( _state => {
        if (ff.myCM_chkType(pd_nexts[_state], 'fcn')) pd_nexts[_state] = bf.p(_o_this.state[_state], pd_nexts[_state]);
      });
      _o_this.setState( pd_nexts, async () => {
        _o_this.d_crls.d_myRNs.b_stt = false;
        _o_end1();
      });
*/
      Object.keys(pd_nexts)
      .map( _state => { // これ、機能するの？
        if (ff.myCM_chkType(pd_nexts[_state], 'fcn')) { // immer の場合
          if (!_o_this.state[_state]) { // state が定義されていない場合
            _o_this.setState({ // dny の新設のみ対応, list 等は未対応
              [_state]: {},
            }, () => {
              pd_nexts[_state] = bf.p(_o_this.state[_state], pd_nexts[_state]);
//ff.l('811: {}, {}'.f(_state, pd_nexts[_state]))
            });
          }
          else {
            pd_nexts[_state] = bf.p(_o_this.state[_state], pd_nexts[_state]);
//ff.l('816: {}, {}'.f(_state, pd_nexts[_state]))
          };
        }
      });
//ff.l('820: here')
      _o_this.setState( pd_nexts, async () => {
        _o_this.d_crls.d_myRNs.b_stt = false;
        _o_end1();
      });
    }
  }
  else {
    _o_end1();
  }
});

static myCB_callQrys = (pd={
  l_tgts: [],
  l_trgs: [],
  d_vals: {
  },
  vsn: 0,
}) => new Promise( async _o_end1 => {

  if (pd.b_ect == false) {
    _o_end1();
  }
  else {
    let _vsn = pd.vsn ?? 0;

    let _l = [];
    Object.keys(iElm.d_elmDefs).map( _elm => {
      Object.keys(iElm.d_elmDefs[_elm][_vsn].dd_fldDefss).map( _fld => {
        if (ff.f(iElm.d_elmDefs[_elm][_vsn].dd_fldDefss[_fld].lo_qrys)) {
          _l.push(cf.f(_fld));
        }
      });
    });
    let _dd_qryss = cf.myRN_getFldDefs(_l);

    if (bf.f(pd.l_tgts)) {
      for await (let [_idx, _tgt] of  ff.e(pd.l_tgts)) {
        if (_dd_qryss[_tgt]) { // iElm を直接参照すれば、dd_qryss を定義不要？
          for await (let [_idx, _o_qry] of ff.e(_dd_qryss[_tgt].lo_qrys)) {
            let _qry = _o_qry(pd.d_vals);
            if (bf.f(_qry)) {
              await cf.myCB_call_iud({
                ctr: 'qrys',
                elm: '----',
                l_qrys: [_qry], 
              })
            };
          };
        }
        else {
          alert('1334: incorrect tgt {} at myCB_callQrys '.f(_tgt))
        };
      };
//ff.l('cf 904: here')
      if (pd.op_atrAll) await pd.op_atrAll(); 
//ff.l('cf 906: here')
      _o_end1();
    };

    if (bf.f(pd.l_trgs)) {
      for await (let [_idx, _trg] of ff.e(pd.l_trgs)) {
        for await (let [_idx, _tgt] of ff.e(_dd_qryss)) {
          if (bf.i(_trg, _dd_qryss[_tgt].l_trgs)) {
            await cf.myCB_callQrys({
              l_tgts: [_tgt],
              dd_qryss: _dd_qryss,
              d_vals: pd.d_vals,
            });
          };
        };
      };
      _o_end1();
    };
  }

});

  static myCB_call_upl = (pd={
    elm: '',
    fld: '',
    key: '',
    d_files: {},
  }) => {
    return new Promise((resolve, reject)=>{
      if (bf.f(pd.d_files.uri) && pd.d_files.lct == 'int') { // uri が 指定されており http画像以外の場合
        //
        let _ld_valss = [];
        //
        if (!cf.myRN_chk_os('w')) { // ios/android の場合
          _ld_valss = [
            {key:'data', vals:{ usr:global.t?.state.sgc_user_key, tkn:global.t?.state.sgc_tkn, ctr:'upl', prc:'', vwi:'', idc:'{}/{}'.f(pd.elm, pd.key), fld:'',
              val:{mode:'open', flds:{file:pd.fld}, type:'file'} // 単一のフィールドに変更する必要あり
            }},
            {key:'file', vals:{
              uri: pd.d_files.uri, name: pd.d_files.name, type: pd.d_files.type,
            }}
          ];
        }
        else{ // web の場合
          _ld_valss = [
            {key:'data', vals:{ usr:global.t?.state.sgc_user_key, tkn:global.t?.state.sgc_tkn, ctr:'upl', prc:'', vwi:'', idc:'{}/{}'.f(pd.elm, pd.key), fld:'',
              val:{mode:'open', fld:pd.fld, type:'base64', base64:pd.d_files.uri.split(',')[1], name:pd.d_files.name} 
            }},
          ];
        };
        //
        cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        })
        .then((_a_res) => {
            resolve(_a_res);
        })
        .catch((_err) =>{
            reject(_err);
        }); 
          
      }
      else {
        reject('incorrect file.');
      };
    });
  };

  static myCB_call_ver(){
    return new Promise((resolve, reject)=>{
      //
      if (!bf.f(ic.g_url1)){
        resolve(null);
      };
      //
      let _ld_valss = [
        {key:'data', vals:{ usr:'-1', tkn:'', ctr:'ver', prc:'', vwi:'', idc:'/', fld:'',
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        resolve(_a_res);
      })
      .catch((_err) => {
        reject(_err);
      });
    });
  };

  static myCB_load_tree = (pd={
    state: '',
    d_pntItems: {}, // defined only at root
    elm: '',
    o_cnd: _d_items => {},
    do_rfrs: {},
    l_flds: [''],
    d_cldDefs: { // same with pd
      elm: '',
      cnd: _d_items => {},
      do_rfrs: {},
      l_flds: [],
      d_cldDefs: {},
    },
    b_newLine: false, // with new line
    b_mplLine: false, // multiple line
    b_row: false,
  }) => new Promise( async _o_end1 => {

    let _cnd = pd.o_cnd(pd.d_pntItems) || '';

    await cf.myCB_call_slc({
      elm: pd.elm, 
      n_dms: 3, 
      cnd: _cnd,
      do_rfrs: pd.do_rfrs,
    })
    .then( async _ld_iss => {

      if (pd.b_newLine == true) { // 空白行ありの場合
        if (
          pd.b_mplLine == true || // 複数行の場合
          (pd.b_mplLine != true && !bf.f(_ld_iss)) // 単数行で値がない場合
        ) {
          _ld_iss = bf.c(_ld_iss, [{
            _key: 'new',
          }]);
        };
      }

      let _ld_treeItemss = await Promise.all(_ld_iss.map( async _d_items => { // map で async を使用する場合、await Promise.all で括る
        //
        let _ld_fldss = pd.ld_fldss.map( _d_flds => {
          return bf.c(_d_flds, { // phd を指定したい場合は、呼び出し元の ld_fldss を設定
            ini: _d_items[_d_flds.fld],
            val: _d_items[_d_flds.fld],
            b_uid: false,
          });
        });
        //
        let _ld_cldElmss = [];
        if (bf.f(pd.d_cldDefs)) {
          await cf.myCB_load_tree(bf.p(pd.d_cldDefs, _next => {
            _next.d_pntItems = _d_items;
          }))
          .then( _res => {
            if(bf.f(_res)) {
              _ld_cldElmss = _res;
            }
          });
        };            
        //
        return { // _d_treeItems
          elm: pd.elm,
          key: _d_items._key,
          b_dlt: false,
          b_cls: false,
          ld_fldss: _ld_fldss,
          ld_cldElmss: _ld_cldElmss,
          d_is: _d_items, // 各fldにおいて d_is を参照するために必要
         };
      }));

      if (bf.f(pd.state)) {
        global.t?.setState({
          [pd.state]: _ld_treeItemss,
        }, () => {
          _o_end1(_ld_treeItemss);
        });
      }
      else {
        _o_end1(_ld_treeItemss);
      };    
    });
  });

  static myCB_ups_tree = (pd={
    elm: '', // only for identification
    pntKey: '',
    ld_elmss: [],
    o_insFlds: (_d_elms, _pntKey) => {},
    do_updFlds: {'fldName': (_d_elms, _pntKey) => {}},
    d_cldDefs: {}, // same with pd
  }) => new Promise( async _o_end1 => {
    let _pntKey = pd.pntKey || '';
    await pd.ld_elmss?.map( _d_elms => {
      if (_d_elms.b_dlt == true) { // 削除データの場合
        if ('{}'.f(_d_elms.key).substr(0,3) == 'new') { // 新規データの場合
          //// 対応事項なし
        }
        else { // 既存データの場合
          let _d = {
            ['{}cz10'.f(_d_elms.elm)] : '0', // 非表示
          };
          let _cnd = `_key = {}`.f(_d_elms.key);
          cf.myCB_call_iud({
            ctr: 'upd', 
            elm:_d_elms.elm, 
            d_vals: _d, 
            cnd: _cnd
          })
          .then(() => {
          });
        };
      }
      else { // 削除データではない場合
        new Promise ( async _o_end3 => {
          if ('{}'.f(_d_elms.key).substr(0,3) == 'new') { // 新規データの場合
            let _d = pd.o_insFlds(_d_elms, _pntKey);
            cf.myCB_call_iud({
              ctr: 'ins', 
              elm: _d_elms.elm, 
              d_vals: _d
            })
            .then( _res => {
                _o_end3(_res._key);
            })
          }
          else { // 既存データの場合
            if (bf.f(pd.do_updFlds)) {
              let _cnd = `_key = {}`.f(_d_elms.key);
              await _d_elms.ld_fldss.map( _d_flds => { // fld ごとにデータを更新
                if (_d_flds.b_uid == true) {
                  let _d = {
                    [_d_flds.fld]: pd.do_updFlds[_d_flds.fld](_d_elms, _pntKey)
                  };
                  if (bf.f(_d)) {
                    cf.myCB_call_iud({
                      ctr: 'upd', 
                      elm: _d_elms.elm, 
                      d_vals: _d, 
                      cnd: _cnd
                    });
                  };
                };
              });
            };
            _o_end3(_d_elms.key);
          };
        })
        .then( async _crrKey => {
          if (bf.f(_d_elms.ld_cldElmss)) { // 子要素が存在する場合
            cf.myCB_ups_tree(bf.p(pd.d_cldDefs, _next => {
              _next.pntKey = _crrKey;
              _next.ld_elmss = _d_elms.ld_cldElmss;
            }));
          };
        });
      };
    });
    _o_end1();
  });

  static myCB_hlr = (pd={ // handler
    elm: '',
    mode: 'get/set/itemss/clds/ins/upd/ups',
    d_vals: {}, // ins/upd/ups
    cnd: '',
    b_clr: false, // get/set
    state: '', // items/clds
    od_setDefs: (pd_is) => {}, // set
    od_itemsDefs: (pd_is) => {}, // items
    od_upsDefs: () => {},
    b_wotDlt: false, // items
    do_rfrs: {
      fld: _d_items => o_cnd(_d_items),
    }, // items
    dld_pcksss: {
      fld: [
        {key:'', pfx:''},
      ],
    }, // items
    ld_sortss: [
      { fld:'_key', dtn:'asc' }
    ], // items
  }) => new Promise( _o_end1 => {

    if (pd.mode == 'get') {
      if (pd.b_clr == true) {
        _o_end1(null);
      }
      else {
        cf.myCB_call_slc({
          elm: pd.elm, 
          n_dms: 2,
          cnd: pd.cnd,
        })
        .then( _d_is => {
          _o_end1(_d_is);
        });
      };
    }
    else if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            elm: pd.elm, 
            n_dms: 2, 
            cnd: pd.cnd
          })
          .then( _d_is => {
            _o_end2(_d_is);
          });
        };
      })
      .then( _d_rs => {
        _d_rs = bf.f(_d_rs) ? _d_rs : {};
        global.t?.setState(
          pd.od_setDefs(_d_rs), 
          () => {
            _o_end1(_d_rs);
          }
        );
      })
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: pd.elm, 
        n_dms: 3,
        state: pd.state, 
        cnd: pd.cnd,
        do_rfrs: pd.do_rfrs,
        dld_pcksss: pd.dld_pcksss,
        ld_sortss: pd.ld_sortss,
        o_fnc: _d_items => {
          let _d_rss = pd.od_itemsDefs(_d_items);
          _d_rss.b_dlt = (pd.b_wotDlt == true && _d_items['{}cz10'.f(pd.elm)] == '0') ? true : false; // b_wotDlt == true かつ cz10 == '0' は 表示対象外
          return _d_rss;
        },
      })
      .then( _ld_rss => {
        _o_end1(_ld_rss)
      });
    }
    else if (pd.mode == 'clds') {
      cf.myCB_set_clds(
        {
          elm: pd.elm, 
          n_dms: 3, 
          cnd: pd.cnd || '',
          state: pd.state,
          b_withCnd: pd.b_withCnd || false, // false の場合 cnd == '' では値が検索されない
          do_rfrs: pd.do_rfrs,
          dld_pcksss: null, // pd.dld_pcksss は反映しない 区分値が置き換わるため
          ld_sortss: pd.ld_sortss,
        }
      )
      .then( (_ld_iss) => {
        _o_end1(_ld_iss);
      });
    }
    else if (pd.mode == 'file') {
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: pd.elm, 
        n_dms: 3, 
        cnd: pd.cnd,
        b_withCnd: true, // false の場合 cnd == '' では値が検索されない
        do_rfrs: pd.do_rfrs,
        dld_pcksss: pd.dld_pcksss,
        ld_sortss: pd.ld_sortss,
      })
      .then( _ld_iss => {
        let _ld = bf.c(
          [pd.od_fileDefs().hdr],
          _ld_iss.map( _d_is => {
            return pd.od_fileDefs(_d_is).val
          })
        );
        let _s = _ld.join('\n');
        _o_end1(_s);
      });
    }
    else if (pd.mode == 'ins') {

      new Promise( _o_end2 => { // 登録前の重複チェック
        if (pd.o_cndCw10) {
          cf.myCB_call_slc({
            ctr: 'nlm',
            elm: pd.elm,
            n_dms: 2,
            cnd: pd.o_cndCw10(),
          })
          .then( _d_elms => {
            if (bf.f(_d_elms) == false) {
              _o_end2(true);
            }
            else {
              _o_end2(false);
            };
          });
        }
        else {
          _o_end2(true);
        };
      })
      .then( _b_noDct => { // no duplicate
        if (_b_noDct) {
          let _d_vals = (pd.d_vals) ? pd.d_vals : pd.od_insDefs();
          cf.myCB_call_iud({
            ctr: 'ins', 
            elm: pd.elm,
            d_vals: _d_vals, // 個別データが指定されている場合、個別データを優先（ファイルアップロードを考慮？）
          })
          .then( _d_rs => {
            _o_end1(_d_rs);
          });
        }
        else {
          alert('IDが重複しているため保存できませんでした');
          _o_end1(null);
        };
      })
    }
    else if (pd.mode == 'upd') {

      new Promise( _o_end2 => { // 登録前の重複チェック
        if (pd.o_cndCw10) {
          cf.myCB_call_slc({
            ctr: 'nlm',
            elm: pd.elm,
            n_dms: 2,
            cnd: pd.o_cndCw10(),
          })
          .then( _d_elms => {
            if (bf.f(_d_elms) == false) {
              _o_end2(true);
            }
            else {
              _o_end2(false);
            };
          });
        }
        else {
          _o_end2(true);
        };
      })
      .then( _b_noDct => { // no duplicate
        if (_b_noDct) {
          if (bf.f(pd.cnd)) {
            cf.myCB_call_iud({
              ctr: 'upd', 
              elm: pd.elm, 
              d_vals: (pd.d_vals) ? pd.d_vals : pd.od_updDefs(), // 個別データが指定されている場合、個別データを優先（ファイルアップロードを考慮？）
              cnd: pd.cnd
            })
            .then( () => {
              _o_end1();
            });
          }
          else {
            alert('891:incorrect cnd at myCB_hlr: {}, {}, {}'.f(pd.elm, pd.mode, pd.cnd));
          };
        }
        else {
          alert('IDが重複しているため保存できませんでした');
          _o_end1(null);
        };
      });
    }
    else if (pd.mode == 'ups') {
      if (bf.f(pd.cnd)) {
        cf.myCB_call_iud({
          ctr: 'ups', 
          elm: pd.elm, 
          d_vals: (pd.d_vals) ? pd.d_vals : pd.od_upsDefs(), 
          cnd: pd.cnd
        })
        .then( _n_key => {
          _o_end1(_n_key);
        });
      }
      else {
        alert('901:incorrect cnd at myCB_hlr: {}'.f(pd.cnd));
      };
    }
    else if (pd.mode == 'upsIs') {
      if (bf.f(pd.cnd)) {
        cf.myCB_call_iud({
          ctr: 'ups', 
          elm: pd.elm, 
          d_vals: (pd.d_vals) ? pd.d_vals : pd.od_upsDefs(), 
          cnd: pd.cnd
        })
        .then( () => {
          _o_end1();
        });
      }
      else {
        alert('901:incorrect cnd at myCB_hlr: {}, {}'.f(pd.elm, pd.cnd));
      };
    }
    else if (pd.mode == 'iudClds') {
      global.t?.state[pd.state].map( _d_is => { 
        let _d = pd.od_iudCldsDefs( _d_is );
        if (bf.f(_d.d_vals) && bf.f(_d.cnd)) {
          cf.myCB_call_iud({
            ctr: 'ups', 
            elm: pd.elm, 
            d_vals: _d.d_vals, 
            cnd: _d.cnd,
          })
          .then(() => {
            if (_d.o_atr) { // after
              _d.o_atr();
            }
          });
        };
      });
      _o_end1();
    }
    else {
      alert('905:incorrect mode at myCB_hlr: {}'.f(pd.mode));
    };

  });

  ////////////////////////////////////////////////////////////////////////
static myCL_set = p_text => new Promise( async _o_end1 => {
  await Clipboard.setString(p_text);
  _o_end1();
});

static myCL_get = () => new Promise( async _o_end1 => {
  let _text = await Clipboard.getStringAsync() ?? null;
//  let _text = await Clipboard.getString() ?? null;
  _o_end1(_text);
});

  ////////////////////////////////////////////////////////////////////////
  static myCR_xhr(pd={
    mode:'POST',
    url:'', 
    ld_valss:[], 
  }) { // pld_valss = [{key:'file', vals:{'uri':'', 'name':'', 'type':'image/jpg'}}], p_name : input element name // ファイルは１回に１つしか送れない？
    return new Promise(async (_o_end1, _o_err1) => {

      let _body = new FormData();

      if (pd.ld_valss) {
        for await (let [_idx, _d_vals] of bf.e(pd.ld_valss)) {
          if (_d_vals.key == 'data') {
            _body.append('data', bf.s(_d_vals.vals));
          };
          if (_d_vals.key == 'file') { // 1bodyに含められるfileは1つのみ
            _body.append('file', _d_vals.vals);
          };
        };
      };

      let _xhr = new XMLHttpRequest();
      _xhr.open(pd.mode, pd.url, true);
      _xhr.responseType = 'json';
      _xhr.send(_body);
      _xhr.onreadystatechange = () => {
        if( _xhr.readyState === 4 && _xhr.status === 200 ) { // _xhr.status が 0 の場合は、nginx の conf.d を確認
          _o_end1(_xhr.response);
        }
      };
      _xhr.onerror = () => {
        _o_err1(_xhr.statusText);
      };

    });
  };
    
  //////////////////////////////////////////////////////////////////////// for local storage

  static myLS_clr() { // clear : remove all items.
    return new Promise( _o_end1 => {
      AsyncStorage.clear(()=>{
        _o_end1();
      });
    });
  }    

  static myLS_chk() { // asyncstorage ( = cookie を利用可能かの確認 )
    return new Promise( _o_end1 => {
      const _key = 'CheckAsyncStorage';
      const _val = 'Enabled'
      cf.myLS_set(_key, _val)
      .then( _b_res => {
        if ( _b_res == true ) {
          cf.myLS_get(_key)
          .then(_res => {
            if ( _res == _val ) {
              cf.myLS_rmv(_key)
              .then(() => {
                _o_end1(true);
              });
            }
            else {
              _o_end1(false);
            }
          });
        }
        else {
          _o_end1(false);
        };
      });
    });
  };

  static myLS_rmv(p_key) { // remove
    return new Promise( _o_end1 => {
      if (ic.gb_dbg) { // 開発
        AsyncStorage.removeItem(p_key)
        .then( () => {
          _o_end1(true);
        })
        .catch( _err => {
          _o_end1(false);
        });
      }
      else { // 本番
        AsyncStorage.removeItem(bf.myCM_hash(p_key))
        .then( () => {
          _o_end1(true);
        })
        .catch( _err => {
          _o_end1(false);
        });
      };
    });
  }    

  static myLS_get(p_key, pb_cpt=true) { // 値が存在しない場合は null、promise を用いた並列化を検討要
    return new Promise( _o_end1 => {
      if (ic.gb_dbg || pb_cpt == false) { // 開発
        AsyncStorage.getItem(p_key)
        .then( _j => {
//ff.l('cf 1534: here')
          _j = bf.j(_j);
          _o_end1(_j);
        })
        .catch( _err => {
//ff.l('cf 1539: here')
          _o_end1(null);
        });
      }
      else { // 本番
        AsyncStorage.getItem(bf.myCM_hash(p_key))
        .then( async _j => {
//ff.l('cf 1546: here')
          _j = await bf.myCM_cpt('d', _j, ic.g_srt_key);
          _j = bf.j(_j);
//ff.l('cf 1549: {}, {}'.f(p_key, _j))
          _o_end1(_j);
        })
        .catch( _err => {
//ff.l('cf 1552: here')
          _o_end1(null);
        });
      };
    })
  };

  static myLS_set(p_key, pa_val, pb_cpt=true) {
    return new Promise( _o_end1 => {
      if (ic.gb_dbg || pb_cpt == false) { // 開発
        AsyncStorage.setItem(
          p_key, 
          bf.s(pa_val)
        )
        .then( () => {
          _o_end1(true);
        })
        .catch( _err => {
          _o_end1(false);
        });
      }
      else { // 本番
        AsyncStorage.setItem(
          bf.myCM_hash(p_key), 
          bf.myCM_cpt('e', bf.s(pa_val), ic.g_srt_key)
        )
        .then( () => {
          _o_end1(true);
        })
        .catch( _err => {
          _o_end1(false);
        });
      };
    });
  };

static myLS_loadStt = (
  pd_stts,
  po_this=null,
) => new Promise( async _o_end1 => {
  let _o_this = po_this ?? global.t;
  if (pd_stts) {
    let _d = {};
    await Promise.all(
      Object.keys(pd_stts).map( async _stt => {
        await cf.myLS_get(_stt)
        .then( _d_ress => {
          _d[_stt] = (_d_ress != undefined) ? _d_ress : pd_stts[_stt];
        });
      })
    )
    .then(() => {
      cf.myRN_setStt(_d, _o_this)
      .then(() => {
        _o_end1();
      });
    })
  }
  else {
    _o_end1();
  };
});

static myLS_saveStt = (
  pd_stts,
  po_this= null
) => new Promise( async _o_end1 => {
  let _o_this = po_this ?? global.t;
  if (_o_this.d_crls.d_myLSs.b_stt) { // 実行中の場合
    cf.myCM_wait(0.01)
    .then(() => {
      cf.myLS_saveStt(pd_stts)
      .then(() => {
        _o_end1();
      });
    });
  }
  else {
    _o_this.d_crls.d_myLSs.b_stt = true;
    if (pd_stts) {
      let _d = {};
      await Promise.all(
        Object.keys(pd_stts)
        .map( async _stt => {
          if (pd_stts != undefined && pd_stts[_stt] != undefined) {
            await cf.myLS_set(_stt, pd_stts[_stt])
            .then( () => {
              _d[_stt] = pd_stts[_stt];
            });
          }
        })
      )
      .then(() => {
        cf.myRN_setStt(_d, _o_this)
        .then(() => {
            _o_this.d_crls.d_myLSs.b_stt = false;
            _o_end1();
        });
      });
    };
  };
});    

static myLS_setStt = (
  p_sttName, 
  pd_vals, 
  po_this=null
) => new Promise ( _o_end1 => {
  let _o_this = po_this ?? global.t;
  _o_this.setState({
    [p_sttName]: pd_vals,
  }, () => {
    cf.myLS_saveStt(p_sttName, po_this)
    .then(() => {
      _o_end1(true);
    })
    .catch( _err => {
      _o_end1(false);
    });
  })
});

    //////////////////////////////////////////////////////////////////////// for file-system

  static myFS_get_rootFdr() {
    return FileSystem.documentDirectory + 'Download/';
  };                                    

  static myFS_make_fdr(p_fdr) { // make folder
    return new Promise((resolve, reject)=>{
      FileSystem.readDirectoryAsync(p_fdr)
      .catch((_err)=>{ // フォルダが存在しなかった場合
        FileSystem.makeDirectoryAsync(p_fdr);
      })
      resolve();
    });
  };

  static async myFS_open_url(p_url, p_name){ // not support web
    if (cf.myRN_chk_os('i')) {
      FileSystem.downloadAsync(p_url, p_name)
      .then((_d_ress) => { // 
        Sharing.shareAsync(p_name)
      });
    };
    if (cf.myRN_chk_os('a')) {
      FileSystem.downloadAsync(p_url, p_name)
      .then( async _d_ress => { // 
        const _d_pmns = await MediaLibrary.requestPermissionsAsync();
        if (_d_pmns.status === "granted") {
          const _ast = await MediaLibrary.createAssetAsync(p_name);
          const _abm = await MediaLibrary.getAlbumAsync('Download');
          if (_abm === null) {
            await MediaLibrary.createAlbumAsync('Download', _ast, false);
          } else {
            await MediaLibrary.addAssetsToAlbumAsync([_ast], 'Download', false);
          };
          alert('ファイルをDownloadフォルダにダウンロードしました')
        };
      });
    };
  };

  static myFS_pck_file() { // file picker
    return new Promise((resolve, reject) => {
      DocumentPicker.getDocumentAsync({
        multiple: true,
        copyToCacheDirectory: true, // google drive のファイルを upload する際に必要？
      })
      .then(async (_d_files)=>{
        if (_d_files.type == 'success') {
          _d_files.lct = 'int'
          resolve(_d_files); // android の場合 myCR_xhr で理由不明のエラー 同一ネットワークにないため？
        }
        else {
          reject();
        };
      });
    });
  };

  //////////////////////////////////////////////////////////////////////// for image-picker

  static async myIP_chk_pms(p_msg) {
    if (Platform.OS == 'ios') {
      const { status } = await ImagePicker.requestCameraRollPermissionsAsync(Permissions.CAMERA_ROLL); // 変数名 status を変更してはいけないもよう
      if ( status !== 'granted') {
        Alert.alert(p_msg);
      }
    }
  };

  static async myIP_pick_img(po_fnc, p_type) {
    //
    if (p_type == 'all') {
      let _d_ress = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.All,
        allowsEditing: false,
        quality: 1,
      });
      if (!_d_ress.cancelled) { // uri:_res.uri
        po_fnc(_d_ress);
      };
    }
    else if (p_type == 'image') {
      let _d_ress = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: false,
        quality: 1,
      });
      if (!_d_ress.cancelled) { // uri:_res.uri
        po_fnc(_d_ress);
      };
    }
    else if (p_type == 'video') {
      let _d_ress = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Videos,
        allowsEditing: false,
        quality: 1,
      });
      if (!_d_ress.cancelled) { // uri:_res.uri
        po_fnc(_d_ress);
      };
    };
  };

  //////////////////////////////////////////////////////////////////////// for react-navigation
/*
  static myNV_stt_move = (pd={ // React Native Web において、画面の再描画・後戻り時に引数を正しく引用できないため、myLS は使用しない
    sgc_pageName: '',
  }) => { // 子に渡す変数を pd_vals に指定
    if (pd.pageName != cf.myNV_get_name()) { // 異なる画面の場合のみ遷移
      let _o_this = global.t;
      global.t = null; // 遷移後の画面において、componentDidMount 前に、古い po_this が参照されることを防ぐ
      //
      _o_this.props.navigation.dispatch( // navigate 前に dispatch しないと Can't perform a React state update on an unmounted component
        CommonActions.reset({ // web の戻る操作を無効化（historyを毎回削除）
          index: 0,
          routes: [{
            name: pd.pageName,
            params: { prms: cf.myNV_cpt_prms(pd.d_prms) },
          }]
        })
      );
      _o_this.props.navigation.navigate(
        pd.pageName, 
        {
          prms: cf.myNV_cpt_prms(pd.d_prms)
        },
      ); // React Native Web において、画面の再描画・後戻り時に引数を正しく引用できないため、myLS は使用しない
    }
  };
*/
  static myNV_stt_move = (pd={ // React Native Web において、画面の再描画・後戻り時に引数を正しく引用できないため、myLS は使用しない
    sgc_pageName: '',
  }) => new Promise( _o_end1 => { // 子に渡す変数を pd_vals に指定
    if (pd.pageName != cf.myNV_get_name()) { // 異なる画面の場合のみ遷移
//    if (true) { // 異なる画面の場合のみ遷移
      let _o_this = global.t;
      global.t = null; // 遷移後の画面において、componentDidMount 前に、古い po_this が参照されることを防ぐ
      //
      _o_this.props.navigation.dispatch( // navigate 前に dispatch しないと Can't perform a React state update on an unmounted component
        CommonActions.reset({ // web の戻る操作を無効化（historyを毎回削除）
          index: 0,
          routes: [{
            name: pd.pageName,
            params: { prms: cf.myNV_cpt_prms(pd.d_prms) },
          }]
        })
      );
      _o_this.props.navigation.navigate(
        pd.pageName, 
        {
          prms: cf.myNV_cpt_prms(pd.d_prms)
        },
      ); // React Native Web において、画面の再描画・後戻り時に引数を正しく引用できないため、myLS は使用しない
      //
      _o_end1();
    }
  });

  static myNV_end_move(po_this) { // 親からのpd_vals を返す
    return new Promise( _o_end1 => { // web で再描画することを考慮し _tmp を myLS_rmv しない
      let _r = cf.myNV_get_prms(po_this);
      _o_end1(_r);
    });
  };

  static myNV_cpt_prms = (pd) =>  {
    let _srt = 'joizaFFG{}fGAfgFGve3{}'.f(ic.g_app_name, ic.g_app_name); // app ごとに異なる srt とする
    let _r = bf.s(pd);
//ff.l('1772: {}'.f(_r));
    _r = bf.myCM_cpt('e', _r, _srt);
//ff.l('1774: {}'.f(_r));
//    _r = bf.myCM_cnv('ecdBase64', _r); // base64 に変換しないと通らない
    _r = bf.myCM_ecd('base64', _r); // base64 に変換しないと通らない
    return _r
  };

  static myNV_get_prms = (po_this=null) => {
    let _srt = 'joizaFFG{}fGAfgFGve3{}'.f(ic.g_app_name, ic.g_app_name); // app ごとに異なる srt とする
    let _o_this = (po_this) ? po_this : global.t;
    let _r = 
      (_o_this.props.route.params) ? 
        _o_this.props.route.params['prms'] 
      : null;
    _r = bf.myCM_dcd('base64', _r); // base64 に変換しないと通らない
    _r = bf.myCM_cpt('d', _r, _srt);
    _r = bf.j(_r);
    return _r;
  };

  static myNV_getId = (po_this=null) => {
    let _o_this = (po_this) ? po_this : global.t;
    let _r = null;
    if (_o_this.props.route.params) {
//ff.l('cf 1864: here')
      _r = _o_this.props.route.params['id'];
    } 
//ff.l('cf 1867: {}'.f(_r))
    return _r;
  };

  static myNV_get_name(po_this=null) { // get current screen name
    let _o_this = (po_this) ? po_this : global.t;
    let _name = 
      (_o_this.props.route.name) ?
        _o_this.props.route.name
      : null;
    return _name;
  };

  //////////////////////////////////////////////////////////////////////// for react native

/*
static myRN_setInsDats = (pd={
  state: null,
  als: null, // option
  elm: null,
  d_insFlds:null,
  ld_arsss: null,
}) => new Promise( _o_end1 => {
  cf.myRN_setStt({
    [pd.state]: _next => {
      let _als1 = pd.als ?? pd.elm;
      let _key = `new${ff.myCM_gnr(10)}`;
      _next[_als1] = [{
        key: _key,
        b_upd: false,
        b_new: true,
        b_dlt: false,
        d_flds: pd.d_insFlds,
        dld_cldDatsss: 
          (pd.dld_cldDatsss) ?
            {
              [pd.dld_cldDatsss.elm]: [{
                key: _key,
                b_upd: false,
                b_new: true,
                b_dlt: false,
                elm: pd.dld_cldDatsss.elm,
                d_flds: pd.dld_cldDatsss.d_insFlds,
                ld_arsss: [
                  { als: _als1, key: _key, },
                  { als: pd.dld_cldDatsss.elm, key: _key, },
                ],
              }]
            }
          : null
        ,
        ld_arsss: [
          { als: _als1, key: _key, }
        ],
      }];
    },
  })
  .then(() => {
    _o_end1();
  });
});
*/

/*
static myRN_setInsDats = (pd={
  state: null,
  als: null, // option
  elm: null,
  d_insFlds:null,
  ld_arsss: null,
}) => new Promise( _o_end1 => {
  cf.myRN_setStt({
    [pd.state]: _next => {
      let _als1 = pd.als ?? pd.elm;
      let _key = `new${ff.myCM_gnr(10)}`;
      let _ld_arsss = ff.myCM_copy(pd.ld_arsss ?? []);
      _ld_arsss.push({ als: _als1, key: _key, });
      let _ld_arsss2 = ff.myCM_copy(_ld_arsss ?? []);
      if (pd.dld_cldDatsss?.elm) _ld_arsss2.push({ als: pd.dld_cldDatsss.elm, key: _key });
      let _d_insDats = {
        elm: pd.elm,
        key: _key,
        b_upd: false,
        b_new: true,
        b_dlt: false,
        d_flds: pd.d_insFlds,
        dld_cldDatsss: 
          (pd.dld_cldDatsss) ?

            {
              [pd.dld_cldDatsss.als ?? pd.dld_cldDatsss.elm]: [{
                elm: pd.dld_cldDatsss.elm,
                key: _key,
                b_upd: false,
                b_new: true,
                b_dlt: false,
                d_flds: pd.dld_cldDatsss.d_insFlds,
                ld_arsss: _ld_arsss2,
              }]
            }
          : null
        ,
        ld_arsss: _ld_arsss,
      };

      if (pd.ld_arsss) {
        let _d_crrDats = cf.myRN_getDat(_next, pd.ld_arsss);
        if (!_d_crrDats.dld_cldDatsss) _d_crrDats.dld_cldDatsss = {};
        if (!_d_crrDats.dld_cldDatsss[_als1]) _d_crrDats.dld_cldDatsss[_als1] = [];
        _d_crrDats.dld_cldDatsss[_als1].push(_d_insDats);
      }
      else {
        if (!_next[_als1]) _next[_als1] = [];
        _next[_als1].push(_d_insDats);
      };
    },
  })
  .then(() => {
    _o_end1();
  });
});
*/

static myRN_setInsDats = (pd={ // myRN_crtDats, myRN_addDats に統合要
  state: null,
  als: null, // option
  elm: null,
  d_insFlds:null,
  ld_arsss: null,
  b_clr: null, // 現要素を初期化する場合
  opb_chkIns: null,
}) => new Promise( _o_end1 => {
  cf.myRN_setStt({
    [pd.state]: _next => {
      let _als1 = pd.als ?? pd.elm;
      let _key = `new${ff.myCM_gnr(10)}`;
      let _ld_arsss = ff.myCM_copy(pd.ld_arsss ?? []);
      _ld_arsss.push({ als: _als1, key: _key, });
      let _d_insDats = {
        elm: pd.elm,
        key: _key,
        b_upd: false,
        b_new: true,
        b_dlt: false,
        d_flds: ff.myCM_copy(pd.d_insFlds), // 初期化
        ld_arsss: _ld_arsss,
      };

      if (pd.dld_cldDatsss) { // 複数の子要素への対応
        let _dld_cldDatsss = {};
        Object.keys(pd.dld_cldDatsss).map(_als2 => {
          let _ld_arsss2 = ff.myCM_copy(_ld_arsss ?? []);
          _ld_arsss2.push({ als: _als2, key: _key });
          _dld_cldDatsss[_als2] = [{
            elm: pd.dld_cldDatsss[_als2].elm,
            key: _key,
            b_upd: false,
            b_new: true,
            b_dlt: false,
            d_flds: ff.myCM_copy(pd.dld_cldDatsss[_als2].d_insFlds), // 初期化
            ld_arsss: _ld_arsss2,
          }];
        })
        _d_insDats.dld_cldDatsss = _dld_cldDatsss;
      }

      if (pd.ld_arsss) { // 子要素の場合
        let _d_crrDats = cf.myRN_getDat(_next, pd.ld_arsss);
        if (!_d_crrDats.dld_cldDatsss) _d_crrDats.dld_cldDatsss = {};
        if (!_d_crrDats.dld_cldDatsss[_als1]) _d_crrDats.dld_cldDatsss[_als1] = [];
        _d_crrDats.dld_cldDatsss[_als1].push(_d_insDats);
      }
      else { // 直要素の場合
        if (!_next[_als1] || pd.b_clr == true) _next[_als1] = [];
        _next[_als1].push(_d_insDats);
      };
    },
  })
  .then(() => {
    _o_end1();
  });
});

static myRN_crtDats = (pd={
  elm: null,
  d_insFlds: null,
  als: null, // optional
}) => {
  let _als = pd.als ?? pd.elm;
  let _key = `new${ff.myCM_gnr(10)}`;
  let _ld_arsss = [{ als: _als, key: _key }];
  let _d_insDats = {
    elm: pd.elm,
    key: _key,
    b_upd: false,
    b_new: true,
    b_dlt: false,
    d_flds: ff.myCM_copy(pd.d_insFlds), // 初期化
    ld_arsss: _ld_arsss,
  };
  return _d_insDats;
};

static myRN_addDats = (pd={
  state: null,
  als: null,
  d_dats: null,
  d_prtDats: null, //optional
}) => new Promise( _o_end1 => {

  let _als = pd.als;
  let _d_dats = ff.myCM_copy(pd.d_dats);

  cf.myRN_setStt({
    [pd.state]: _next => {

      if (pd.d_prtDats) { // 親要素が指定されている場合
        let _ld_crrArsss = pd.d_prtDats.ld_arsss;
        let _ld_cldArsss = ff.myCM_copy(_ld_crrArsss);
//ff.l('2041: {}'.f(_ld_cldArsss));
//        _ld_cldArsss.push({ als: _als, key: _d_dats.d_flds.key });
        _ld_cldArsss.push({ als: _als, key: _d_dats.key });
        _d_dats.ld_arsss = _ld_cldArsss;

        let _d_prtDats = cf.myRN_getDat(_next, _ld_crrArsss);
        if (!_d_prtDats.dld_cldDatsss) _d_prtDats.dld_cldDatsss = {};
        if (!_d_prtDats.dld_cldDatsss[_als]) _d_prtDats.dld_cldDatsss[_als] = [];
        _d_prtDats.dld_cldDatsss[_als].push(_d_dats);

      };
      if (!pd.d_prtDats) { // 親要素が指定されてない場合
        if (!_next) _next = {};
        if (!_next[_als]) _next[_als] = [];
        _next[_als].push(_d_dats);
//ff.l('2051: {}, {}, {}, {}'.f(pd.state, _als, _d_dats, _next[_als]))
      };
    },
  })
  .then(() => {
//ff.l('2055: {}, {}'.f(pd.state, global.t?.state[pd.state]))
    _o_end1();
  });
});

static myRN_chgPageMode = (pd={
  mode: null, // sttNew, endNew, cclNew, sttEdit, endEdit, cclEdit
  als: null,
  elm: null,
  state: null,
  d_insDats: null, // 廃止予定
  d_insFlds:null,
  op_atrAll: null,
}) => new Promise( async _o_end1 => {

  if (pd.mode == 'sttNew') {
    if (pd.opb_chkIns && await pd.opb_chkIns() != true) { // スキップ
      _o_end1();
    }
    else {
      cf.s();
      cf.myRN_setStt({ // パラメータの初期化 cView.op_loadDtlAll に統合？
        ...global.t?.$cd_stss,
        ...global.t?.$id_stss
      })
      .then(() => {
        cf.myRN_setInsDats(pd)
        .then(async () => {
          if (pd.op_atrAll) await pd.op_atrAll(); // 初期値設定後の後処理を定義
          global.t?.setState({
            sgc_pageKey: -1,
            sgc_pageMode: 'new',
            sgc_pnlMode: 'dtl',
            sgcn_step: 0,
          }, () => {
            cf.h();
            _o_end1();
          });
        });
      })
    }
  };

  if (pd.mode == 'endNew') {
    cf.s();
    global.t?.op_upd()
    .then(() => {
      cf.myRN_savePageStgs({
        sgc_pageMode: 'show',
      })
      .then(() => {
        cf.h();
        _o_end1();
      });
    })
  };

  if (pd.mode == 'cclNew') {
    cf.s();
    cf.myRN_savePageStgs({
      sgc_pageMode: 'show',
      sgc_pnlMode: 'list',
    })
    .then(() => {
      global.t?.op_loadListAll({b_clr: false})
      .then(() => {
        cf.h();
        _o_end1();
      }); // dtl から list へ戻った際、リストに変更を反映するために必要
    });
  };

  if (pd.mode == 'sttEdit') {
    cf.myRN_savePageStgs({
      sgc_pageMode: 'edit',
    })
    .then(() => {
      _o_end1();
    })
  };

  if (pd.mode == 'endEdit') { // 変更結果を保存
    cf.s();
    global.t?.op_upd()
    .then(() => {
      cf.myRN_savePageStgs({
        sgc_pageMode: 'show',
      })
      .then(() => {
        cf.h();
        _o_end1();
      });
    })
  };

  if (pd.mode == 'cclEdit') {
    cf.s();
    global.t?.op_loadDtlAll()
    .then(() => {
      cf.myRN_savePageStgs({
        sgc_pageMode: 'show',
      })
      .then(() => {
        cf.h();
        _o_end1();
      });
    });
  };

  if (pd.mode == 'dlt') {
    cf.myRN_showMdl({
      mdl: 'cfm',
      msg: pd.msg ?? 'この情報を削除して宜しいですか？',
      ld_btnss: [
        {
          pfx: 'はい',
          o_onPrs: () => {
            cf.s();
            global.t?.op_dltAll()
            .then(() => {
              cf.myRN_savePageStgs({
                sgc_pageMode: 'show',
                sgc_pnlMode: 'list',
              })
              .then(() => {
                global.t?.op_loadListAll({b_clr: false})
                .then(() => {
                  cf.h();
                  _o_end1();
                }); // dtl から list へ戻った際、リストに変更を反映するために必要
              });
            })
          },
        },
        {
          pfx: 'いいえ',
          o_onPrs: () => {
          },
        }
      ]
    });
  };

});

static myRN_chgPnlMode = (pd = {
}) => new Promise( _o_end1 => {
  if (pd.mode == 'list') {
    cf.myRN_savePageStgs({
      sgc_pageKey: -1,
    })
    .then(() => {
      global.t?.op_loadListAll()
      .then(() => {
        cf.myRN_savePageStgs({
          sgc_pnlMode: 'list',
        })
        .then(() => {
          _o_end1();
        });
      }); // dtl から戻った際、list の表示に必要
    })
  };
});

  static myRN_crt_stss(pd_vals1, pd_vals2=null) {
    if (bf.f(pd_vals2)){
      const _r = bf.myCM_upd(bf.myCM_upd(bf.myCM_upd(pd_vals1, pd_vals2), ic.gd_stss1), ic.gd_stss2);
      return _r;
    }
    else {
      const _r = bf.myCM_upd(bf.myCM_upd(pd_vals1, ic.gd_stss1), ic.gd_stss2);
      return _r;
    };
  };

  static myRN_chk_os(p_os) {
    let _r = false;
    if (Platform.OS == 'android' && p_os == 'a') {
      _r = true;
    };
    if (Platform.OS == 'ios' && p_os == 'i') {
      _r = true;
    };
    if (Platform.OS == 'web' && p_os == 'w') {
      _r = true;
    };
    return _r;
  };

  static myRN_chk_tkn(po_fnc1, po_fnc2) {
    if ( bf.f(global.t?.state.sgc_user_key) && bf.f(global.t?.state.sgc_tkn)) { // user_key および tkn が設定されている場合
      let _cnd1 = `_key = {} AND user3210 = '{}'`.f(global.t?.state.sgc_user_key, global.t?.state.sgc_tkn);
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: 'user', 
        n_dms: 2, 
        cnd: _cnd1
      })
      .then( _d_users =>{
        if (bf.f(_d_users)) { // tkn が一致していた場合
          if (po_fnc1) {
            po_fnc1();
          };
        }
        else { // tkn が誤っていた場合
          if (po_fnc2) {
            po_fnc2();
          };
        };
      });
    }
    else { // user_key または tkn が設定されていない場合
      if (po_fnc2) {
        po_fnc2();
      };
    };
  };

  static myRN_cnv(p_mode, pa_val){
    if (p_mode == 'ecdBase64') { // encoded base64 日本語未対応？
      const Buffer = require("buffer").Buffer;
      return (pa_val) ? new Buffer(pa_val).toString('base64') : null;
    };

    if (p_mode == 'dcdBase64') { // decoded base64
      return (pa_val) ? base64.decode(pa_val) : null;
    };
  };

  static myRN_get_mimeType(p_file) {
    return mime.lookup(p_file);
  };

  static myRN_get_uri(p_str) {
    //
    if (!bf.f(p_str) || p_str.slice(0,1) != '{') {
      return null;
    };
    //
    return '{}/{}'.f(ic.g_url2, bf.p(p_str).file)
  };

static myRN_getFldVal = (pd_dats, p_fld1, p_fld2, p_fld3) => {
  let _r = (pd_dats.dd_stgss?.[p_fld1]?.d_rfrs) ? pd_dats.dd_stgss?.[p_fld1]?.d_rfrs.d_flds[p_fld2] : pd_dats.d_flds[p_fld3];
  return _r;
}

static myRN_cnvFldVal = (pd_dats, p_fld, pld_iss=null) => { // 廃止予定
  let _elm = String(p_fld).substr(0, 4);
  let _d_fldDefs = cf.e(_elm).dd_fldDefss[p_fld];
  if ( bf.i(_d_fldDefs.type, ['Chk', 'Pck', 'PckSlc'])) {
//ff.l('2205: {}'.f(pld_iss));
    return ff.myCM_getDny({ ld_iss: pld_iss ?? _d_fldDefs.ld_iss, fld: 'key', val: pd_dats.d_flds[p_fld]}).pfx
  }
  else {
    return pd_dats.d_flds[p_fld]
  } 
}

static myRN_getFldDefs(pld_fldDefss) {
  let _d = {};
  pld_fldDefss
  .map( (_d_fldDefs, _idx) => {
    if (_d_fldDefs) {
      _d[_d_fldDefs.fld] = { // 項目の前後関係によって決まる項目のみ定義、通常は cf.f にて定義
        n_sort: _idx,
        ..._d_fldDefs
      };
    };
  });
  return _d;
}

static myRN_ldr = (po_fnc) => new Promise( _o_end1 => { // show loader
  global.t?.setState({
    sgcb_showLdr: true
  }, async () =>{
    await po_fnc();
    global.t?.setState({
      sgcb_showLdr: false
    }, () =>{
      _o_end1();
    });
  });
});

static myRN_showLdr() { // show loader
  return new Promise( _o_end1 => {
    global.t?.setState({
      sgcn_prs: 0,
      sgcb_showLdr: true
    }, () =>{
      _o_end1();
    });
  });
}

static myRN_hideLdr() { // hide loader
  return new Promise( _o_end1 => {
//ff.l('cf 2405: here')
    global.t?.setState({
      sgcn_prs: 0,
      sgcb_showLdr:false
    }, () =>{
      _o_end1();
    });
  });
}

static myRN_showMdl = (pd={}) => {
  global.t?.setState({
    sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
      _next[pd.mdl] = {
        ...pd,
        b_showMdl: true
      };
    })
  })
};

  static myRN_msg_get_grpKey(p_elm ,p_key){ // get message group Key
    return new Promise( _o_end1 => {
      let _cnd = '[ct21l11e]="{}" AND [ct21l11k]="{}"'.f(
        p_elm,
        p_key,
      );
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: 'ct21', 
        n_dms: 2, 
        cnd: _cnd
      })
      .then( _d_ct21s => {
        if (bf.f(_d_ct21s)) { // メッセージグループが存在した場合
          _o_end1(_d_ct21s._key);
        }
        else { // メッセージグループが存在しなかった場合は追加
          let _d_vals = {
            ct21l11e: p_elm,
            ct21l11k: p_key,
            ct21c110: '',
            ct21cz10: '10',
          };
          cf.myCB_call_iud({
            ctr: 'ins', 
            elm: 'ct21', 
            d_vals: _d_vals
          })
          .then( _d_ct21s => {
            _o_end1(_d_ct21s._key);
          });
        };
      });
    });
  };

  static myRN_msg_cnv_msg(pld_ct20ss){ // get message
    return new Promise(async _o_end1 => {
      //
      let _r = [];
      let _dd_cashss = {};
      //
      for await (let [_idx, _d_ct20s] of bf.e(pld_ct20ss)) {
        //
        // 登録者情報の取得
        let _cnd2 = '_key = {}'.f(_d_ct20s.ct20cy20);
        await cf.myCB_call_rfr(_d_ct20s, 'cm10', _cnd2, '', _dd_cashss)
        .then(async _d_ct20s => {
          //
          if (_d_ct20s.ct20c410 == '10'){ // メッセージの場合
            _r.push({
              type: 'msg',
              chb: false,
              key: '{_key}'.f2(_d_ct20s),
              name: '{cm10c310}'.f2(_d_ct20s),
              msg: '{ct20c610}'.f2(_d_ct20s),
              time: '{ct20cy10}'.f2(_d_ct20s),
              sort: '{ct20cy10}'.f2(_d_ct20s),
              vals: _d_ct20s,
            });
          };
          if (_d_ct20s.ct20c410 == '20'){ // ファイルの場合
            //
            // ファイル情報の取得
            let _cnd3 = '[ct10l11e]="ct20" AND [ct10l11k]="{}"'.f(_d_ct20s._KEY);
            await cf.myCB_call_rfr(_d_ct20s, 'ct10', _cnd3, '')
            .then( _d_ct20s => {
              //
              if (bf.f(_d_ct20s.ct10c610)) {
                _r.push({
                  type: 'file',
                  chb: false,
                  key: '{_key}'.f2(_d_ct20s),
                  name: '{cm10c310}'.f2(_d_ct20s),
                  file: {
                      name: bf.j('{ct10c610}'.f2(_d_ct20s)).name,
                      url: '{}/{}'.f(ic.g_url2,bf.j('{ct10c610}'.f2(_d_ct20s)).file),
                  },
                  time: '{ct20cy10}'.f2(_d_ct20s),
                  sort: '{ct20cy10}'.f2(_d_ct20s),
                  vals: _d_ct20s,
                });
              };
            });
          };
        })
      };
      _o_end1(_r);            
    });
  };

  static myRN_msg_upd_lastDtm(p_ct21Key, p_cm10Key){
    let _d_vals = {
      ct22b11k: p_ct21Key,
      ct22b21k: p_cm10Key,
      ct22i110: bf.myDT_getNow(),
    }
    let _cnd =  '[ct22b11k]="{}" AND [ct22b21k]="{}"'.f(
      p_ct21Key,
      p_cm10Key,
    );
    cf.myCB_call_iud({
      ctr: 'ups', 
      elm: 'ct22', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then(()=>{
      // 未読件数の初期化
      global.t?.setState({
          sgcn_msgCnt: 0,
      });
    })
  };

  static myRN_pll(plo_pmss) { // parallel
    return new Promise( _o_end1 => {
      Promise.all(plo_pmss)
      .then(async _lb_ress =>{
        let _b = true;
        for await (let [_idx, _b_res] of bf.e(_lb_ress)){
          if (_b_res == false) { // 各 pms の戻り値に一つでも false が存在する場合は false を返す
            _b = false;
            break;
          };
        };
        _o_end1(_b); // myRN_hideLdr の後に then した場合、正しく処理されない場合がある模様
      })
      .catch((_err) => {
        alert('1055:{}, {}'.f(_err, plo_pmss))
      })
    });
  };

  static myRN_load = (plo_pmss) => new Promise( _o_end1 => {
    cf.myRN_pll(plo_pmss)
    .then(()=>{
      _o_end1();
    });
  });

  static myRN_ins(po_pms) { // sgc_pageKey への設定は、個別に行う必要がある
    return po_pms
    .then( _d_is => {
      new Promise( _o_end1 => {
        if (bf.f(_d_is)) {
          global.t?.setState({
//            sgc_pageKey: _d_is._KEY
            sgc_pageKey: _d_is._key
          }, ()=>{
            _o_end1();
          });
        }
        else {
          _o_end1();
        };
      })
      .then(()=>{
        global.t?.upd();
      });
    });
  };

/*
static myRN_move_fwd = async (pd={}) => {
  if (global.t?.op_onExit) await global.t?.op_onExit(pd);
  cf.myLS_saveStt({
    sgcd_cmnStgs: global.t?.state.sgcd_cmnStgs,
  })
  .then(() => {
    cf.myRN_savePageStgs({
      sgc_pageMode: pd.sgc_pageMode,
    }, pd.sgc_pageName)
    .then(() => {
      let _d = {
        pageName: pd.sgc_pageName,
        d_prms: {
          sgc_pageName: pd.sgc_pageName,
          sgc_pageRole: pd.sgc_pageRole,
          sgc_pageMode: pd.sgc_pageMode,
          sgcn_pageTab: pd.sgcn_pageTab ?? 1,
        },
      }
      cf.myNV_stt_move(_d);
    });
  });
};
*/
static myRN_move_fwd = (pd={}) => new Promise( async _o_end1 => {
  if (global.t?.op_onExit) await global.t?.op_onExit(pd);
  cf.myLS_saveStt({
    sgcd_cmnStgs: global.t?.state.sgcd_cmnStgs,
  })
  .then(() => {
    cf.myRN_savePageStgs({
      sgc_pageMode: pd.sgc_pageMode,
    }, pd.sgc_pageName)
    .then(() => {
      let _d = {
        pageName: pd.sgc_pageName,
        d_prms: {
          sgc_pageName: pd.sgc_pageName,
          sgc_pageRole: pd.sgc_pageRole,
          sgc_pageMode: pd.sgc_pageMode,
          sgc_pnlMode: pd.sgc_pnlMode, // 20211227 追加
          sgc_pageKey: pd.sgc_pageKey, // 20211227 追加
          sgc_pageFst: pd.sgc_pageFst, // 20211227 追加
          sgcn_pageTab: pd.sgcn_pageTab ?? 1,
        },
      }
      cf.myNV_stt_move(_d)
      .then(_o_end1);
    });
  });
});

static myRN_logout() {
  // LS の削除
  cf.myLS_clr() // global.t? が存在しなくとも実行
  .then(()=>{
    // TOP 画面へ遷移
    let _d_pageInfs = {
      pageName: ic.g_iniPageName,
      d_prms: {
        sgc_pageRole: ic.g_iniPageRole,
        sgc_pageMode: 'show',
      },
    };
    cf.myNV_stt_move(_d_pageInfs); // global.t? を極力介さないため、myRN_move_fwd は使用しない
  });
};

  static myRN_getDy = (po_this) => { // キーボードの表示に伴う移動量 android の場合、_dy が実態と一致するよう調整した後、Hdr の top を調整
    if (po_this.state.sgcd_msrs.y == undefined) return 0;
    let _dy = (po_this?.state.sgcd_msrs.y + po_this?.state.sgcd_msrs.h) - (po_this?.state.sgcd_kbds.screenY);
    if (_dy >= (po_this?.state.sgcd_kbds.height - ic.gn_ftrH)) _dy = po_this?.state.sgcd_kbds.height - ic.gn_ftrH; // キーボード分のみが対象
    if (_dy < 0) _dy = 0; // 下側が被った場合のみが対象
    return _dy;
  };

  static myRN_stt = async (po_this, po_fnc) => { // この中では、global.t ではなく po_this を使用

    po_this.d_crls = { // 画面描画に影響を与えない state 設定
      ...po_this.d_crls,
      b_mnt: true, // mounted
      b_hdn: false, // 表示中
      d_myRNs: {},
      d_myLSs: {},
    };

    global.d_crls = { // 画面描画に影響を与えない state 設定
      ...global.d_crls,
      o_updLastOrnDtm: () => {
        global.d_crls.lastOrnDtm = ff.myDT_getNow();
        //ff.l('ff 2698: {}'.f(global.d_crls.lastOrnDtm))
      },
      n_noOrnTime: null, // no operation time
    };

    if (!cf.myRN_chk_os('w')){ // version check
      cf.myCB_call_ver()
      .then((_d_ress)=>{
        if (_d_ress.result != ic.g_ver) { // バージョンをチェックし、最新化
          alert('最新のプログラムをダウンロードください。');
        };
      })
      .catch((_err)=>{
        alert('1458:'+bf.s(_err));
      })
    };

    po_this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (_e) => { //_e.endCoodinates.height : keyboard height
        if (bf.f(po_this.state.sgcd_kbds) == false) { // この判定がないと、表示がばたつく
          po_this.setState({
            sgcd_kbds: _e.endCoordinates,
          }, () =>{
            if (cf.myRN_chk_os('a') == false) { // android は自動調整
              po_this.setState({
                sgcn_dy: cf.myRN_getDy(po_this),
              });
            };
          });
        }
    });

    po_this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', (_e) => {
        po_this.setState({
          sgcd_kbds: {},
        }, () => {
          if (cf.myRN_chk_os('a') == false) { // android は自動調整
            po_this.setState({
              sgcn_dy: 0,
            });
          };
        });
    });

    po_this.dmnLnr = Dimensions.addEventListener('change', _evt => { // dimensions listener
      po_this.setState({
        sgcd_dmns: {
          n_w: _evt.window.width,
          n_h: _evt.window.height,
          n_bdyW:
            (_evt.window.width > ic.gn_maxBdyW) ?
              ic.gn_maxBdyW
            : (_evt.window.width < ic.gn_minBdyW) ?
              ic.gn_minBdyW
            : _evt.window.width
          ,
          n_bdyH: _evt.window.height - (ic.gn_hdrH + ic.gn_ftrH),
        },
      }, () => {
      });
    });

//ff.l('cf 2750: {}'.f(cf.myNV_get_name(po_this)));
    po_this.focusListener = po_this.props.navigation.addListener("focus", () => { // 画面遷移時に再描画するために必要 2/4 po_this は旧・global.t は新であることに注意
//ff.l('cf 2752: {}'.f(cf.myNV_get_name(po_this)));

      if (po_this.d_crls.b_mnt != true) return; // when unmounted
      
      global.t = po_this; // current component, defined at ic.js、move_bwd で切り替わることを考慮し willFocus の中で設定

      //ff.l('cf 2684: {}, {}'.f(global.t?.d_viewDefs.class, cf.myNV_getId(po_this)));

//ff.l('cf 2760: {}'.f(cf.myNV_get_name(po_this)));
      cf.myNV_end_move(po_this)
      .then( _d_vals => {
//ff.l('cf 2763: {}'.f(cf.myNV_get_name(po_this)));

        //ff.l('cf 2731: {}'.f(_d_vals));
        po_this.setState(_d_vals, ()=>{ // この段階で、前コンポーネントからの情報が引き継がれる、global.t にした場合、move_bwd で実行されない模様
//ff.l('cf 2767: {}'.f(cf.myNV_get_name(po_this)));

          StatusBar.setHidden(true); // status bar を非表示

          cf.myRN_pll([
            cf.myLS_loadStt({sgcd_cmnStgs: {}}, po_this), // 初期化
            cf.myLS_loadStt({sgcd_pageStgs: {}}, po_this), // 初期化
            new Promise( _o_end1 => {
              cf.myLS_get('lastOrnDtm')
              .then( _dtm => {
                //ff.l('ff 2768: {}'.f(_dtm))
                let _lastOrnDtm = (ff.f(_dtm)) ? _dtm : ff.myDT_getNow();
/*
                po_this.d_crls = { // 画面描画に影響を与えない state 設定
                  ...po_this.d_crls,
                  lastOrnDtm: _lastOrnDtm, // last operation date time
                };
*/
                global.d_crls = { // 画面描画に影響を与えない state 設定
                  ...global.d_crls,
                  lastOrnDtm: _lastOrnDtm, // last operation date time
                };
                _o_end1();
              })
            }),
          ])
          .then( ()=>{
//ff.l('cf 2776: {}'.f(cf.myNV_get_name(po_this)));
            let _pageName = cf.myNV_get_name(po_this);
            if (
              ff.i(_pageName, [ic.g_iniPageName, 'c00vm', 'cdr']) == false && bf.f(po_this.state.sgcd_cmnStgs?.c10r_key)
            ) {
              let _cnd = cf.c('c10r', `_key = ${po_this.state.sgcd_cmnStgs?.c10r_key}`, false, false); // c10r は歴管理の対象外
              cf.myCB_call_slc({
                ctr: 'nlm', 
                elm: 'c10r', 
                n_dms: 2, 
                cnd: _cnd
              })
              .then( _d_c10rs => {
                if (bf.f(_d_c10rs)) {
                  cf.myRN_saveCmnStgs({
                    c10rt11i: _d_c10rs.c10rt11i,
                    c10r_pfx: (_d_c10rs.c10rc31s) ? _d_c10rs.c10rc31s : (_d_c10rs.c10rc33s ?? ''),
                  }, po_this)
                  .then(()=>{
                    if (po_fnc){
                      po_fnc();
                    };
                  });
                }
                else {
                  cf.myRN_logout();
                }
              });
            }
            else{
              if (ff.i(_pageName, [ic.g_iniPageName, 'c00vm', 'cdr'])) {
                if (po_fnc){
                  new Promise( _o_end1 => { // サブドメインに紐づいた利用会社・認証区分の設定
                    let _d_dmns = myWB.myWB_getDmn(); // サブドメインが存在する場合のみ有効
                    let _cnd = `c01rc11s = "${_d_dmns.subDmn}"`;
                    cf.myCB_call_slc({
                      ctr: 'nlm',
                      elm: 'c01r',
                      n_dms: 3, // 3 でないと dd_rfrss が機能しない
                      cnd: _cnd,
                      dd_rfrss: {
                        c20r: {
                          elm: 'c20r',
                          o_cnd: _d_flds => {
                            let _cnd = cf.c('c20r', `_fst = ${_d_flds.c01rb21f}`, true, true); // c20r_fst がまだ設定されてない
                            return _cnd;
                          }
                        },
                      }
                    })
                    .then( _ld_c01rss => {
                      if (ff.f(_ld_c01rss)) {
                        let _d_c01rs = _ld_c01rss[0];
                        cf.myRN_saveCmnStgs({
                          c20r_fst: _d_c01rs.c01rb21f, // 利用会社
                          c20r_pfx: (_d_c01rs.c20rc31s) ? _d_c01rs.c20rc31s : (_d_c01rs.c20rc33s ?? ''), // 利用会社名
                          c01rt11i: _d_c01rs.c01rt11i, // 利用者区分
                          c01rt21i: _d_c01rs.c01rt21i, // 認証区分
                        })
                        .then(() => {
                          _o_end1();
                        })
                      }
                      else {
                        cf.myRN_saveCmnStgs({
                          c20r_fst: -1, // 利用会社
                          c20r_pfx: '', // 利用会社名
                          c01rt11i: -1, // 利用者区分
                          c01rt21i: -1, // 認証区分
                        })
                        .then(() => {
                          _o_end1();
                        });
                      };
                    })
                  }).then(() => {
                    po_fnc();
                  });
                };
              }
              else {
//ff.l('cf 2804: here')
                // ff.l('2739: here');
                cf.myRN_logout();
              }
            };
          })
        });
      });

    });
  };

  static myRN_end() { // 他の画面から戻ってくるごとに実行される、focusLitener は記載しない 戻ってきた際に myRN_stt の addListner が実行されず global.c　が設定されない模様
//ff.l('cf 2810: {}'.f(global.t?.d_crls?.b_mnt))
    if (global.t?.d_crls?.b_mnt) {
      global.t.d_crls.b_mnt = false; // unmounted
      global.t?.focusListener();
      global.t?.keyboardDidShowListener?.remove();
      global.t?.keyboardDidHideListener?.remove();
      global.t?.dmnLnr?.remove();
    };
  };

static myRN_eptCsv = (pd={
  name: '',
  hdr: '',
  op_bldVal: _ld_valss => new Promise( _o_end1 => {}),
  ld_sortss: [
    {fld:'', dtn:'desc/asc', mode:'nmb/str'},
  ],
  o_listVal: d_vals => ({}),
}) => {
  cf.s();
  let _ld_valss = [];
  pd.op_bldVal(_ld_valss)
  .then( () => {
    let _csv = bf.myCM_sort({      // 並べ替え
      ld_iss: _ld_valss,
      ld_sortss:pd.ld_sortss,
    })
    .reduce( (_prev1, _d_vals) => {      // CSV生成
      let _s = pd.o_listVal(_d_vals)
      .reduce( (_prev2, _val) => {
        return ((_prev2 != null) ? '{},'.f(_prev2) : '') + '"{}"'.f(String(_val ?? '').replace(/"/g, '”'))
       }, null);
      return _prev1 + '\n' + _s
    }, pd.hdr);

    if ( cf.myRN_chk_os('w') ) { // web の場合
      let _fileName = '{}_{}.csv'.f(
        pd.name, 
        bf.myDT_getNow().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,8)
      );
      df.myFL_ept({      // ファイル出力
        fileName: _fileName,
        val: _csv,
      });
      cf.h();
    }
    else { // web 以外の場合
      cf.myRN_ept({
        fileName: '{}_{}.csv'.f(
          pd.name, 
          bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)
        ),
        val: _csv,
      });
      cf.h();
    };
  })
};

static async myRN_ept(pd={ // react native file export
  fileName: '',
  val: '',
}) {
  let _fileUri = FileSystem.documentDirectory + encodeURI(pd.fileName); // 日本語ファイル名への対応
  await FileSystem.writeAsStringAsync(_fileUri, pd.val, { encoding: FileSystem.EncodingType.UTF8 });
  await Sharing.shareAsync(_fileUri)
};

  static myRN_open_url = (p_url) => new Promise( _o_end1 => {
    if (cf.myRN_chk_os('w') == true) {
//      setTimeout(() => window.open(p_url, '_blank'), 100);
//        window.open(p_url, '_system', 'location=yes,enableViewportScale=yes,hidden=no');
//      window.location = p_url;
//console.log('2948: {}'.f(navigator.userAgent))
//      if (navigator.userAgent.match(/Android.+Mobile/)) {
      if (navigator.userAgent.match(/Android/)) {
        let _url = 'https://docs.google.com/gview?embedded=true&url={}'.f(p_url);
//console.log('2951: {}'.f(_url))
        window.open(encodeURI(_url), '_blank', 'location=yes,EnableViewPortScale=yes');
      } else {
        window.open(p_url, '_blank')
      }
      _o_end1();
    }
    else {
      Linking.openURL(p_url);
      _o_end1();
    }
  });

  static myRN_saveCmnStgs(pd_is, po_this=null) { // set pageMode
    let _o_this = (po_this) ? po_this : global.t;
    return new Promise( _o_end1 => {
      new Promise( _o_end2 => {
        if (!bf.f(_o_this.state.sgcd_cmnStgs)) {
          _o_this.setState({
            sgcd_cmnStgs: {}
          }, () => {
            _o_end2();
          })
        }
        else {
          _o_end2();
        };
      })
      .then(() => {
        cf.myLS_setStt(
          'sgcd_cmnStgs',
          bf.p(_o_this.state.sgcd_cmnStgs, _next => {
            Object.keys(pd_is)
            .filter( _key => bf.f(_key) ? true : false)
            .map( _key => {
              _next[_key] = pd_is[_key];
            });
          }),
          po_this
        )
        .then(() => {
          _o_end1();
        })
      });
    })
  };

static myRN_savePageStgs = (pd_vals, p_pageName=null) => new Promise( _o_end1 => { // getPageStgs は設けない render に反映されないため
  let _pageName = p_pageName || cf.myNV_get_name();
  cf.myLS_setStt('sgcd_pageStgs', bf.p( global.t?.state.sgcd_pageStgs, _next => {
    if (!ff.f(_next[_pageName])) {
      _next[_pageName] = {};
    }
    Object.keys(pd_vals)
    .map( _key => {
      _next[_pageName][_key] = pd_vals[_key];
    });
  }))
  .then(() => {
    global.t?.setState(pd_vals, () => {
      _o_end1();
    })
  });
});

  static myRN_user_ins(p_eml){
    return new Promise ((_o_end1)=>{
      let _eml = bf.myCM_cnv('lwr', p_eml);
      new Promise( _o_end2 => {
        let _d_vals = {
          user1010: _eml,
          user1020: bf.myCM_gnr(128),
          user1030: _eml,
        }
        let _cnd = '[user1010]="{}"'.f(_eml)
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'user', 
          cnd: _cnd,
          n_dms: 2,
        })
        .then( _d_is => {
          if (bf.f(_d_is)) { // 登録済の場合
            _o_end2(_d_is._key);
          }
          else { // 未登録の場合
            cf.myCB_call_iud({
              ctr: 'ins', 
              elm: 'user', 
              d_vals: _d_vals, 
              cnd: _cnd
            })
            .then((_d_is) => {
              _o_end2(_d_is._key);
            });
          }
        })
      })
      .then( _key => {
        let _d_vals = {
          cm10b11k: _key,
          cm10c110: '',
          cm10i110: _eml, // email の重複登録を可能とする場合は、database の重複登録を可能とする
        }
        cf.myCB_call_iud({
          ctr: 'ins', 
          elm: 'cm10', 
          d_vals: _d_vals
        })
        .then((_d_cm10s) => {
          _o_end1(_d_cm10s);
        });
      });
    });

  };

  static myRN_user_upd(p_user_key, p_eml){ // 自分自身の場合は、LS の変更も必要
    return new Promise ((resolve)=>{
      let _eml = bf.myCM_cnv('lwr', p_eml);
      let _d_vals = {
        user1010: _eml,
        user1030: _eml,
      }
      let _cnd = '_key = {}'.f(p_user_key);
      cf.myCB_call_iud({
        ctr: 'upd', 
        elm: 'user', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then(()=>{
        resolve();
      });
    });
  }

  static myRN_prm_stt(p_id='0') { // promise initialize count
    global.t?.setState({
      sgcd_prms: bf.p(global.t?.state.sgcd_prms, _next => {
        _next[p_id] = 0;
      }),
    });
  };

  static myRN_prm_end(p_id='0') { // promise add count
    global.t?.setState({
      sgcd_prms: bf.p(global.t?.state.sgcd_prms, _next => {
        _next[p_id] += 1;
      }),
    });
  };

  static myRN_prm_wait(pn_maxCnt, p_id='0') { // promise add count
    return new Promise( _o_end1 => {
      bf.myCM_clw(0.01, ()=>{
        if (global.t?.state.sgcd_prms[p_id] >= pn_maxCnt) {
          global.t?.setState({
            sgcd_prms: bf.p(global.t?.state.sgcd_prms, _next => {
              delete _next[p_id];
            }),
          });
          return true;
        }
        else {
          return false;
        };
      })
      .then(()=>{
        _o_end1();
      })
    });
  };

  //////////////////////////////////////////////////////////////////////// for message dialog
  static myWD_mdl(p_msg) {
    alert(p_msg,'');
  };

  static myWD_cdl(p_msg, po_fnc1, po_fnc2) {
    Alert.alert(p_msg, '', [{text:'はい', onPress:() => po_fnc1()}, {text:'いいえ', onPress:() => po_fnc2()}]);
  };

  //////////////////////////////////////////////////////////////////////// for websocket

  static myWS_gnr(p_url){ // 常時接続 chn は myWS 経由、ins/upd/rnw は 通常？　基本、全て myWS 経由にし、構造を固める
    return new WebSocket(p_url);
  };

  static myWS_onOpen(p_ws, p_fnc){ // 常時接続 chn は myWS 経由、ins/upd/rnw は 通常？　基本、全て myWS 経由にし、構造を固める
    p_ws.onopen = () => {
      p_fnc();
    };
  };

  static myWS_onRcv(p_ws, p_fnc){ // 常時接続 chn は myWS 経由、ins/upd/rnw は 通常？　基本、全て myWS 経由にし、構造を固める
    p_ws.onmessage = function (_msg) {
      p_fnc(_msg.data);
    };
  };

  static myWS_send_msg(p_ws, p_msg){ // 単発でイベントを発生
    p_ws.send(p_msg);
  };

  static myWS_close(p_ws){ // 単発でイベントを発生
    p_ws.close();
  };

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
